<template>
    <yxtbiz-richeditor
      :max-length="maxLength"
      ref="richeditor"
      app-code="tlive"
      org-code="xxv2"
      function-name="richeditor"
      module-name="test"
    ></yxtbiz-richeditor>
</template>
<script>
export default {
  name: 'LiveRemark',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      maxLength: 5000
    };
  },
  methods: {
    getInnerHtml() {
      return this.$refs.richeditor.getHtml();
    },
    getInnerText() {
      return this.$refs.richeditor.getInnerText();
    }
  }
};
</script>
<style scoped lang="less"></style>
